import { ApiProduct, ApiProject } from "@incendium/api";
import { productService } from "Apis";
import { useMemo } from "react";
import { useProjectSharedState } from "./useSharedState";

const fetchProducts = async (project: ApiProject) => {
  const res = await productService.productServiceListProducts({
    projectId: project.id as number,
  });
  return res.results || [];
};

export const useProducts = () => {
  const { state, setState, refetch, loading, fetched } = useProjectSharedState(
    "products",
    [],
    fetchProducts
  );

  const productsWithBrands = useMemo(
    () => state.filter((p) => !!p.productBrandId),
    [state]
  );
  const productsWithCategories = useMemo(
    () => state.filter((p) => !!p.productCategoryId),
    [state]
  );

  return {
    products: state as ApiProduct[],
    productsWithBrands,
    productsWithCategories,
    setProducts: setState,
    refetch,
    loading,
    fetched,
  };
};
